import React from "react";

import KPIComparison from "components/visuals/KPIComparison";
import useColourPalette from "components/visuals/useColourPalette";
import { Box, Typography } from "@material-ui/core";
import { useAppSelector } from "store";
import { selectIsLoading, selectHasErrors, selectLatestMonthFootfall } from "modules/customer/insights/portfolioNew/footfallNew/footfallNewSlice";
import numberFormatter from "utils/numberFormatter";
import { selectComparator, selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";

const LatestMonthDwellTime: React.FC = () => {
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectStore);
    const comparator = useAppSelector(selectComparator);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const latestMonthFootfall = useAppSelector(selectLatestMonthFootfall);
    const differencePositiveSign = latestMonthFootfall.dwellTime.percentageDifference > 0 ? "+" : "";

    const selectedStoreValue = `${numberFormatter.toDecimalPlaces(latestMonthFootfall.dwellTime.selectedStore, 1)} minutes`;
    const comparatorValue = `${numberFormatter.toDecimalPlaces(latestMonthFootfall.dwellTime.comparator, 1)} minutes`;

    const label = `
        Average dwell time per cell within ${selectedStore?.name}'s retail centre
        (${latestMonthFootfall.latestMonthDate.monthLong} ${latestMonthFootfall.latestMonthDate.year})
    `;
    return (
        <Box width="100%" height="100%" data-cy="average-dwell-time-per-cell">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {selectedStoreValue}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {comparatorValue}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${comparator?.name}`}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(latestMonthFootfall.dwellTime.percentageDifference)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default LatestMonthDwellTime;
